/* globals App  */

import { Rates } from "../components/rates";

class CalculatorPage {
  constructor() {
    this.form = document.getElementById("shippingCalculatorForm");
    this.rates = new Rates(this.form);
    this.packageCount = 1;
    App.forms.create(this.form, {
      ajax: true,
      redirect: false,
      fieldErrors: true,
      highlightFieldErrors: true,
      onSubmit: () => {
        this.rates.onGetRates();
      },
      onSuccess: (data) => {
        this.rates.showRates(data);
      },
      onFail: (data) => {
        this.rates.onError(data);
      },
    });
    this.maxPackages = this.form.querySelector(".js-add-package").dataset.max;
    this.form.querySelector(".js-add-package").addEventListener("click", (e) => {
      e.preventDefault();
      if (this.packageCount >= this.maxPackages) {
        App.modals.getModal("calculatorMaxPackages").open();
      } else {
        this.addPackage();
      }
    });
    console.log("Calculator page initialised");
  }

  addPackage() {
    let elem = this.form.querySelector(".package-details").cloneNode(true);
    var container = this.form.querySelector("[data-form-field=packages]");
    let fields = ["width", "height", "depth", "weight"];
    elem.querySelectorAll(".field-error").forEach((el) => {
      el.remove();
    });
    for (let field of fields) {
      let input = elem.querySelector(`input.${field}`);
      if (!input) {
        input = elem.querySelector(`select.${field}`);
      }
      input.value = "";
      input.name = `packages[${this.packageCount}][${field}]`;
      input.closest(".form-field").classList.remove("has-error");
    }
    elem.querySelector(".dimensions").name = `packages[${this.packageCount}][dimensions]`;
    elem.querySelector(".metric").name = `packages[${this.packageCount}][metric]`;
    elem.querySelector(".js-remove-package").classList.remove("hidden");
    elem.querySelector(".js-remove-package").addEventListener("click", (e) => {
      e.preventDefault();
      elem.remove();
      this.packageCount--;
    });
    container.appendChild(elem);
    this.packageCount++;
  }
}

new CalculatorPage();
